import React from "react";

export default function ToolSplitter() {
  return <div className="splitter" />;
}
